
const getNotification = (state) => {
  return state.notification
}

const getConfig = (state) => {
  return state.config
}

const getVersion = (state) => {
  return state.version
}

const getResponse = (state) => {
  return state.response
}

const getLocation = (state) => {
  return state.location
}

const getNavigation = (state) => {
  return state.navigation
}

const getDrawer = (state) => {
  return state.drawer
}

const getDrawerHidden = (state) => {
  return state.drawer_hidden
}

export {
  getNotification,
  getConfig,
  getVersion,
  getResponse,
  getLocation,
  getNavigation,
  getDrawer,
  getDrawerHidden
}



// WEBPACK FOOTER //
// ./src/store/common/getters.js